// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__31PQ7","form":"styles_form__iUQJf"};